export const SURVEY_OPTIONS_URL = '/survey/options/';
export const SURVEY_AGES_URL = '/respondents/ages';
export const SURVEY_GENDERS_URL = '/respondents/genders';
export const RESPONDENTS_DEMOGRAPHICS_URL = '/respondents/demographics';
export const ENGAGEMENT_SURVEY_ANSWER_URL = 'engagement/answer';
export const MOTIVATOR_SURVEY_ANSWER_URL = 'survey/answer';
export const LOGO_URL = '/accounts/{accountId}/logo';
export const TIPS_URL = '/tip/';
export const TOKEN_REFRESH_URL = '/v2/token/refresh';
export const CUSTOMIZATION_URL = '/v2/accounts/{accountId}/customizations/{customizationType}/{customizationKey}';
export const IDENTITY_URL = '/token/identity';
